import React from 'react';

const FormLayout2 = () => {
    return (
        <div>

        </div>
    );
};

export default FormLayout2;


// WEBPACK FOOTER //
// ./src/components/Common/GenericForms/FormLayout2.js